import { API_METHODS } from "../../constant";
export const attrEntityApi = (
  _getAll,
  _get,
  _update,
  _create,
  _delete,
  paramsIn
) => {
  return {
    [API_METHODS.GET_ATTR_ENTITY]: () => {
      let urlReq = `/AttrEntity/${paramsIn.id}`;
      return _get(urlReq);
    },

    [API_METHODS.GET_ALL_ATTR_ENTITY]: () => {
      let urlReq = `/AttrEntity`;
      return _getAll(urlReq);
    },

    [API_METHODS.UPDATE_ATTR_ENTITY]: () => {
      let urlReq = `/AttrEntity`;
      return _update(urlReq);
    },

    [API_METHODS.CREATE_ATTR_ENTITY]: () => {
      let urlReq = `/AttrEntity`;
      return _create(urlReq);
    },

    [API_METHODS.DELETE_ATTR_ENTITY]: () => {
      let urlReq = `/AttrEntity/${paramsIn.id}`;
      return _delete(urlReq);
    }
  };
};
